export function buildCspeRecordFormDataBuilder(cspeRecord) {    
    const formData = new FormData();
    
    if (cspeRecord.id)
        formData.append('cspe_record[id]', cspeRecord.id);

    formData.append('cspe_record[structure_data_id]', cspeRecord.structure_data_id); 
    formData.append('cspe_record[start_date]', cspeRecord.start_date); 
    formData.append('cspe_record[end_date]', cspeRecord.end_date); 
    formData.append('cspe_record[value]', cspeRecord.value ?? "");

    return formData;
}